/* eslint-disable */
// @ts-nocheck
import React, { useEffect, ChangeEvent, useState, useCallback } from 'react';
import Input from 'components/commercetools-ui/atoms/input';
import Typography from 'components/commercetools-ui/atoms/typography';
import useTranslation from 'providers/i18n/hooks/useTranslation';
import { useParams, usePathname } from 'next/navigation';
import Dropdown from 'components/commercetools-ui/atoms/dropdown';
import RoomDetails from './RoomsDetails';
import Button from 'components/commercetools-ui/atoms/button';
import { projectType, PHONE_PATTERN, EMAIL_PATTERN, projectLocation, projectStatus } from './data';
import { sdk } from 'sdk';
import { useAccount, useProjectBuilder } from 'frontastic';
import Spinner from 'components/commercetools-ui/organisms/spinner';
import { PROJECT_CREATED, PROJECT_UPDATED } from 'helpers/constants/events';
import { ctDataToFormData } from '../components/data';
import SaveConfirmationPopup from './save-confirmation-popup';

type ProjectDetailsProps = {
    activeTab: number;
    handleTabClick: (tabIndex: number, formData: any) => void;
    projectFormData: any;
    setIsFormDirty:any;
    isFormDirty:boolean;
    openSaveConfirmation:boolean;
    setOpenSaveConfirmation:any;
    handleCancelLeave:any;
    handleConfirmLeave:any;
    tabIndexValue:number;
    setActiveTab: (tabIndex: number) => void;
};

type ChangeHandler = (event: ChangeEvent<HTMLInputElement>) => void;

const ProjectDetails: React.FC<ProjectDetailsProps> = ({ activeTab, tabIndexValue, setActiveTab, setIsFormDirty, isFormDirty, handleCancelLeave, handleConfirmLeave, openSaveConfirmation, setOpenSaveConfirmation, handleTabClick, projectFormData }) => {
    const { createShoppingList, updateProjectStatus } = useProjectBuilder();
    const { locale } = useParams();
    const { translate } = useTranslation();
    const [loading, setLoading] = useState<any>(false);
    const pathname = usePathname();
    const { account } = useAccount();
    const isEditPage = pathname.indexOf('/edit') !== -1 || pathname.indexOf('/view') !== -1;

    const requiredFields: any = [
        { name: 'projectName', message: translate(`error.project.name.required`) },
        { name: 'projectType', message: translate('error.project.type.required') },
        { name: 'projectLocation', message: translate('error.project.location.required') },
        { name: 'username', message: translate('error.specifier.username.required') },
        { name: 'selectedRoomDetails', message: translate('error.select.room') },
    ];

    const [formErrors, setFormErrors] = useState<any>({});
    const [selectedRoomErrors, setSelectedRoomErrors] = useState<any>(false);
    const [isSubmitted, setIsSubmitted] = useState<any>(false);
    const [formData, setFormData] = useState<any>({});
    const [selectedRooms, setSelectedRooms] = useState([]);
    const [selectedRoomsFromParent, setSelectedRoomsFromParent] = useState([]);
    const [formEdit, setFormEdit] = useState(false);
    const [disableRoom, setDisableRoom] = useState(false);
    const [createProjectError, setCreateProjectError] = useState('');
    const [filteredProjectLocation, setFilteredProjectLocation] = useState([]);
    const [editFormData, setEditFormData] = useState<any>({});
    const [navigationToDiffStepperid, setNavigationToDiffStepperid] = useState(0);
    

    useEffect(() => {
        setFormEdit(false);
        if (projectFormData) {
            setDisableRoom(true);
            const projectData = {
                projectName: projectFormData.projectName || '',
                username: projectFormData.username || '',
                projectType: projectFormData.projectType || '',
                projectStatus: projectFormData.projectStatus || '',
                projectLocation: projectFormData.projectLocation || '',
            };
            setFormData(projectData);
            if (isEditPage) {
                projectData.shoppingListId = projectFormData.shoppingListId;
                projectData.version = projectFormData.version;
                setEditFormData(projectData);
                setDisableRoom(false);
            }
            setSelectedRoomsFromParent(projectFormData.selectedRoomDetails);
            if (!isEditPage) {
                setFormEdit(true);
            }
        }
    }, [projectFormData]);

    useEffect(() => {
        const filteredLocation = projectLocation.filter((item) => item.region === '*' || item.region === locale);
        setFilteredProjectLocation(filteredLocation);
    }, [locale]);

    useEffect(() => {
        if (!isEditPage && (account?.firstName || account?.lastName)) {
            setFormData((prevData: any) => ({
                ...prevData,
                username: prevData?.username ?? `${account?.firstName || ''} ${account?.lastName || ''}`.trim(),
            }));
        }
    }, [account, isEditPage]);    

    const addMissingRooms = (data) => {
        for (let room of data) {
            const { count, value } = room;
            if (count > value.length) {
                for (let i = 1; i <= count; i++) {
                    if (!value.includes(i)) {
                        value.push(i);
                    }
                    if (value.length === count) break;
                }
                value.sort((a, b) => a - b);
            } else if (count < value.length) {
                room.value = value.slice(0, count);
            }
        }
        return data;
    };

    const handleSelectedRoomsChange = (updatedRooms) => {
        
        setSelectedRooms(addMissingRooms(updatedRooms));
        if (updatedRooms.length) {
            setSelectedRoomErrors(false);
        }
    };

    const handleChange = useCallback((name: string, value: string) => {
        setFormData((prevData: any) => ({ ...prevData, [name]: value }));
    }, []);

    const handleInputChange: ChangeHandler = (event) => {
        setIsFormDirty(true);
        const { name, value } = event.target;
        handleChange(name, value);
        if (isSubmitted) {
            const newErrors = handleValidation({ ...formData, [name]: value });
            if (newErrors[name] !== formErrors[name]) {
                setFormErrors(newErrors);
            }
        }
    };
    const handleDropdownChange: ChangeHandler = (name, option) => {
        setIsFormDirty(true);
        handleChange(name, option);
        if (isSubmitted) {
            const newErrors = handleValidation({ ...formData, [name]: option });

            if (newErrors[name] !== formErrors[name]) {
                setFormErrors(newErrors);
            }
        }
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>, field?: string) => {
        if (field === 'projectName' || field === 'username') {
            const invalidChars = /[!@#$%^&*()_+={}\[\];:'"\\|,.<>?~`]/;
            if (invalidChars.test(event?.key)) {
                event.preventDefault();
            }
        }
        if (event?.key === 'Enter') {
            event.preventDefault();
            handleSubmit(event as any);
        }
    };
    const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>, field: string) => {
        event.preventDefault();
        setIsFormDirty(true);
        let pastedData = event.clipboardData.getData('text');
        if (field === 'projectName' || field === 'username') {
            pastedData = pastedData?.replace(/[!@#$%^&*()_+={}\[\];:'"\\|,.<>?~`]/g, '');
        }
        if (field === 'projectName') {
            pastedData = pastedData?.substring(0, 50);
        }
        if (field === 'username') {
            pastedData = pastedData?.substring(0, 50);
        }
        handleChange(field, pastedData);
    };

    const handleValidation = (values: any) => {
        let errors: any = { ...formErrors };
        Object.keys(values).forEach((key) => {
            const value = values[key];
            switch (key) {
                case 'username':
                    if (!value) {
                        errors[key] = translate('error.specifier.username.required');
                    } else {
                        delete errors[key];
                    }
                    break;
                case 'projectName':
                    if (!value) {
                        errors[key] = translate('error.project.name.required');
                    } else {
                        delete errors[key];
                    }
                    break;
                case 'projectType':
                    if (!value) {
                        errors[key] = translate('error.project.type.required');
                    } else {
                        delete errors[key];
                    }
                    break;
                case 'projectLocation':
                    if (!value) {
                        errors[key] = translate('error.project.location.required');
                    } else {
                        delete errors[key];
                    }
                    break;
                case 'selectedRoomDetails':
                    setSelectedRoomErrors(false);
                    if (!selectedRooms.length) {
                        setSelectedRoomErrors(true);
                    } else {
                        delete errors[key];
                    }
                    break;
                default:
                    break;
            }
        });
        return errors;
    };

    const getChangedValues = (initialForm, updatedForm) => {
        let changes = {};
        for (const key in updatedForm) {
            if (typeof updatedForm[key] === 'object' && updatedForm[key] !== null) {
                if (JSON.stringify(updatedForm[key]) !== JSON.stringify(initialForm[key])) {
                    changes[key] = updatedForm[key].value;
                }
            } else {
                if (updatedForm[key] !== initialForm[key]) {
                    changes[key] = updatedForm[key];
                }
            }
        }
        return changes;
    };


    const getFormattedRoomNames = (selectedValue) => {
        return selectedValue.flatMap(room => {
            if (room.count === 1) {
                return [room.roomName];
            } else if (room.count > 1 && room.value.length > 0) {
                return room.value.map(value => `${room.roomName} ${value}`);
            } else {
                return [];
            }
        });
    };

    const handleSubmit = async (e: any, isPopupConfirmation?:boolean) => {
        setCreateProjectError('');
        e.preventDefault();
        setIsSubmitted(true);
        setSelectedRoomErrors(false);
        setIsFormDirty(false);
        setOpenSaveConfirmation(false);
        let errors: any = {};
        formData['selectedRoomDetails'] = selectedRooms;
        requiredFields.forEach((field) => {
            const value = formData[field.name];
            if (
                value === undefined ||
                value === null ||
                (typeof value === 'string' && !value.trim()) ||
                (Array.isArray(value) && !value.length) ||
                (typeof value === 'object' && !Object.keys(value).length)
            ) {
                errors[field.name] = field.message;
            }
        });
        const validationErrors = handleValidation(formData);
        errors = { ...errors, ...validationErrors };
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            handleCancelLeave();
            setIsFormDirty(true);
            return;
        }
        try {
            setLoading(true);
            if (!isEditPage) {
                const payload = {
                    projectDetails: {
                        projectName: formData.projectName,
                        projectType: formData?.projectType?.value,
                        projectStatus: 'open',
                        projectLocation: formData.projectLocation?.value,
                    },
                    selectedRoomDetails: getFormattedRoomNames(selectedRooms),
                    specifierDetails: {
                        username: formData.username,
                    }
                };
                const responseBody: any = await createShoppingList(payload);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: PROJECT_CREATED,
                    userId: account?.accountId,
                });
                handleTabClick(isPopupConfirmation ? 1: 2, responseBody.shoppingList);
            } else {
                const formChanges = getChangedValues(editFormData, formData);
                if (JSON.stringify(selectedRooms) == JSON.stringify(projectFormData.selectedRoomDetails)) {
                    delete formChanges.selectedRoomDetails;
                } else if (selectedRooms?.length) {
                    formChanges.selectedRoomDetails = getFormattedRoomNames(selectedRooms);
                }

                const payload = {
                    shoppingListId: editFormData.shoppingListId,
                    version: editFormData.version,
                    items: {
                        ...formChanges,
                        ...(formChanges.projectStatus && { status: formChanges.projectStatus }),
                    },
                };
                let tab  = 2;
                if(tabIndexValue !== 0 && activeTab !== tabIndexValue){
                    tab = tabIndexValue;
                }else if(isPopupConfirmation){
                    tab = 1;
                }
                if (Object.keys(payload.items).length) {
                    const responseBody: any = await updateProjectStatus(payload);
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: PROJECT_UPDATED,
                        shoppingListId: editFormData?.shoppingListId,
                        userId: account?.accountId,
                    });

                    handleTabClick(tab, ctDataToFormData(responseBody.shoppingList));
                } else {
                    handleTabClick(tab, projectFormData);
                }
            }
            handleConfirmLeave();
            setLoading(false);
        } catch (error) {
            setLoading(false);
                const errorMessage = error.message?.replace(/^Error:\s*/, '');
            if (errorMessage?.toLowerCase()?.includes('failed to fetch')) {
                setCreateProjectError(translate('error.no.internet'));
            } else if (errorMessage?.includes(translate('error.create.project'))) {
                setCreateProjectError(error.message?.replace(/^Error:\s*/, ''));
                setTimeout(() => setCreateProjectError(''), 3000);
            } else {
                setCreateProjectError(translate('error.wentWrong.retry'));
            }
        }
    };
    const editRoomStyleDisable = !isEditPage && projectFormData ? { opacity: "0.5", cursor: "not-allowed" } : {};
    const discardConfirmation = () => {
        setIsFormDirty(false);
        setOpenSaveConfirmation(false);        
        if(tabIndexValue !== 0 && activeTab !== tabIndexValue){
            setActiveTab(tabIndexValue)
        }
        setTimeout(() => {
            handleConfirmLeave();
        }, 100);
    };

    const closeConfirmation = () => {
        setOpenSaveConfirmation(false);
        handleCancelLeave();
    };

    return (
        <>
            {loading && <Spinner />}
            <form onSubmit={handleSubmit}>
            <div>
                    <Typography className="fontSize18-sm !mb-20 text-black">About the specifier</Typography>
                    <div className="padding-r-38-lg grid gap-[1.5rem] md:flex ">
                        <div className="w-full md:w-1/2 lg:w-full lg:max-w-[385px]">
                            <Input
                                name="username"
                                placeholder={translate('Username*')}
                                value={(formData['username'] as string) ?? ''}
                                error={formErrors['username']}
                                onChange={handleInputChange}
                                onPaste={(event) => handlePaste(event, 'username')}
                                onKeyDown={(event) => handleKeyDown(event, 'username')}
                                tabIndex={0}
                                autoComplete=""
                                className={`mb-20 !p-13 ${formErrors['username'] ? '!border-red-500' : '!border-[#A7A7A7]'
                                    } !rounded-[6px] `}
                                errorClassName="!absolute top-30 left-4"
                                maxLength={50}
                            />
                        </div>
                    </div>
                </div>
                <div className="aboutProject-container">
                    <Typography className="fontSize18-sm !mb-20 text-black">About the project</Typography>
                    <div className="padding-r-38-lg aboutProject grid gap-[1.5rem] md:flex">
                        <div className="aboutProjectFlex">
                            <Input
                                name="projectName"
                                placeholder={translate('Project name*')}
                                value={(formData['projectName'] as string) ?? ''}
                                error={formErrors['projectName']}
                                onChange={handleInputChange}
                                onPaste={(event) => handlePaste(event, 'projectName')}
                                onKeyDown={(event) => handleKeyDown(event, 'projectName')}
                                tabIndex={0}
                                autoComplete=""
                                className={`mb-20 !p-13 ${formErrors['projectName'] ? '!border-red-500' : '!border-[#A7A7A7]'
                                    } !rounded-[6px] `}
                                errorClassName="!absolute top-30 left-4"
                                maxLength={50}
                            />
                        </div>
                        <div className="aboutProjectFlex">
                            <div className="relative projectDropDown !mb-20 lg:w-[245px]" key={'projectType'}>
                                <Dropdown
                                    error={formErrors['projectType']}
                                    selectOptions={projectType}
                                    selectOnChange={(val) => handleDropdownChange('projectType', val)}
                                    disableFirstOption={true}
                                    defaultValue={formData?.projectType ?? projectType[0]}
                                    optionsClassName="!top-37 xl:!top-[38px] md:!top-38 border-light-gray "
                                    clearDropdown={false}
                                    selectDropdownClassNames={`${!formData?.projectType ? 'text-secondary-black' : '!text-black'
                                        } !rounded-[6px] !text-14  border-light-gray text-left overflow-hidden !h-fit !px-13 !py-[8.5px] w-full `}
                                />
                                {formErrors['projectType'] && (
                                    <Typography
                                        className="text-error-600 !absolute left-4 top-30 mt-12 text-12 font-medium leading-[16px]"
                                        as="span"
                                    >
                                        {formErrors?.projectType}
                                    </Typography>
                                )}
                            </div>
                        </div>

                        <div className="aboutProjectFlex">
                            <div className="relative projectDropDown !mb-20 lg:w-[230px]" key={'projectLocation'}>
                                <Dropdown
                                    error={formErrors['projectLocation']}
                                    selectOptions={filteredProjectLocation}
                                    selectOnChange={(val) => handleDropdownChange('projectLocation', val)}
                                    disableFirstOption={true}
                                    defaultValue={formData?.projectLocation ?? projectLocation[0]}
                                    optionsClassName="!top-37 xl:!top-[38px] md:!top-38 border-light-gray "
                                    clearDropdown={false}
                                    selectDropdownClassNames={`${!formData?.projectLocation ? 'text-secondary-black' : '!text-black'
                                        } !rounded-[6px] !text-14  border-light-gray text-left overflow-hidden !h-fit !px-13 !py-[8.5px] w-full `}
                                />
                                {formErrors['projectLocation'] && (
                                    <Typography
                                        className="text-error-600 !absolute left-4 top-30 mt-12 text-12 font-medium leading-[16px]"
                                        as="span"
                                    >
                                        {formErrors?.projectLocation}
                                    </Typography>
                                )}
                            </div>
                        </div>
                    </div>
                    {isEditPage && (
                        <div className="padding-r-38-lg aboutProject grid gap-[1.5rem] md:flex">
                            <div className="relative projectDropDown !mb-20 lg:w-[230px]" key={'projectStatus'}>
                                <Dropdown
                                    error={formErrors['projectStatus']}
                                    selectOptions={projectStatus}
                                    selectOnChange={(val) => handleDropdownChange('projectStatus', val)}
                                    disableFirstOption={true}
                                    defaultValue={formData?.projectStatus ?? projectStatus[0]}
                                    optionsClassName="!top-37 xl:!top-[38px] md:!top-38 border-light-gray "
                                    clearDropdown={false}
                                    selectDropdownClassNames={`${!formData?.projectStatus ? 'text-secondary-black' : '!text-black'
                                        } !rounded-[6px] !text-14  border-light-gray text-left overflow-hidden !h-fit !px-13 !py-[8.5px] w-full `}
                                />
                                {formErrors['projectStatus'] && (
                                    <Typography
                                        className="text-error-600 !absolute left-4 top-30 mt-12 text-12 font-medium leading-[16px]"
                                        as="span"
                                    >
                                        {formErrors?.projectStatus}
                                    </Typography>
                                )}
                            </div>
                        </div>
                    )}
                </div>
                <div className="mt-20" style={editRoomStyleDisable}>
                    <Typography className="fontSize18-sm !mb-20 text-black">Rooms in this project</Typography>
                    <RoomDetails
                        onSelectedRoomsChange={handleSelectedRoomsChange}
                        selectedRoomsParent={selectedRoomsFromParent}
                        disabled={disableRoom}
                        setIsFormDirty={setIsFormDirty}
                    />
                    {selectedRoomErrors && (
                        <Typography className={`!absolute mt-12 text-12 font-medium leading-[16px] text-red-500`} as="span">
                            {translate('error.select.room')}
                        </Typography>
                    )}
                </div>
                <div className="flex items-center">
                    <Button
                        className={`!mb-32 !mt-45 w-full !cursor-pointer rounded-none !bg-gray-700 !px-25 !py-13 text-center text-14 disabled:cursor-auto disabled:!bg-gray-400 md:!mt-[40px] md:w-fit`}
                        type="submit"
                        disabled={formEdit}
                    >
                        Save and continue
                    </Button>
                    <Typography className={`ml-10 mt-12 text-12 font-medium leading-[16px] text-red-500`} as="span">
                        {createProjectError}
                    </Typography>
                </div>
            </form>
            <div className="savepopup-container">
                <SaveConfirmationPopup 
                isOpen={openSaveConfirmation}
                handleDiscard={discardConfirmation}
                handleSaveNContinue={(e) => handleSubmit(e, true)}
                handleClose={closeConfirmation}
                disabledSaveNContinue={formEdit}
                />
            </div>
        </>
    );
};

export default ProjectDetails;
